//export const BASE_URL = "https://pledjeapi-prod.appspot.com/";
export const BASE_URL = "https://test-ef716.appspot.com/";
//export const BASE_URL = "http://localhost:8080/";